import { ApiError } from '@/lib/api';
import { translateBillingError } from '@/lib/billingErrors';

function errorCode(error: unknown): string | undefined {
  if (!(error instanceof ApiError)) return undefined;
  const data = error.data;
  if (typeof data !== 'object' || data === null || !('code' in data)) return undefined;
  return typeof data.code === 'string' ? data.code : undefined;
}

/** invoices.json keys for the consolidated-invoice errors the list and card surface. */
export function consolidationErrorText(
  error: unknown,
  t: (key: string, options?: Record<string, unknown>) => string,
): string {
  const code = errorCode(error);
  if (code === 'consolidation_empty') return t('consolidation.empty');
  if (code === 'not_on_consolidated_invoice') return t('consolidation.notAttached');
  return translateBillingError(error, t);
}
